export default {"src":"/_next/static/image/public/images/ic_up_arrow_black.49f3eeebb04e780dc4e7cb3ccf036225.svg","height":32,"width":32};